module.exports = "data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjI8Bya2wnINUMopZAQA7"


//////////////////
// WEBPACK FOOTER
// ./source/javascripts/vendor/admin/js/libs/jquery.tablesorteskin/desc.gif
// module id = 589
// module chunks = 7 8 9 10